<!-- <div class="entity-selector">
	<span #selectedEntities [ngClass]="{'selected': selected, 'hide': hide, 'error': lastSelectedEntity.error}" *ngIf="lastSelectedEntity">
		{{ lastSelectedEntity.label }}
		<i class="fa fa-times" (click)="removeLastSelectedEntity()"></i>
	</span>
	<input #inputSelector type="text" (keyup)="searchTerm.next($event)" (focus)="selectInput()" [(ngModel)]="inputValue" [ngModelOptions]="{updateOn: 'blur'}" (blur)="leaveInput()" [placeholder]="placeholder">
	<ul *ngIf="results && showEntities">
		<li *ngFor="let result of results">
			<i *ngIf="result.status == 'published'" class="fa fa-circle green"></i>
			<i *ngIf="result.status == 'draft'" class="fa fa-circle red"></i>
			<a href="javascript:void(0)" (click)="selectEntity($event,result)">{{ result.label }}</a>
		</li>
	</ul>
</div> -->
<div class="bb-single-selector" (mouseover)="preloadOptions()" (clickOutside)="toggleOptions(false)">
	
	<div class="value" (click)="toggleOptions()">
		<i class="fa fa-times button" *ngIf="allowClear" [hidden]="! lastSelectedEntity" (click)="removeLastSelectedEntity($event);"></i>
		<span *ngIf="lastSelectedEntity">
			<span [innerHTML]="lastSelectedEntity?.data | statusIcon"></span>
			<span [innerHTML]="lastSelectedEntity.label"></span>
			<em *ngIf="lastSelectedEntity && !lastSelectedEntity.label" class="no-label">{{ lastSelectedEntity?.data?.originalfilename || lastSelectedEntity?.data?.id }}</em>
		</span>
		<span [hidden]="lastSelectedEntity" class="placeholder">{{ placeholder }}</span>&nbsp;
	</div>

	<div class="options-wrapper" [hidden]="!optionsVisible">

		<!-- <div class="options {{$ctrl.optionsPosition}}"> -->
		<div class="options" [class.below]="optionsPosition === 'below'">
			<div class="search">
				<input #searchInput autofocus type="text" (input)="searchTermObservable.next(searchValue)" (keydown)="searchKeyDown.next($event)" (focus)="selectInput()" [(ngModel)]="searchValue" (blur)="leaveInput()" [placeholder]="'SEARCH' | translate" />
				<a class="search-button button icon-only join-left"><i class="fa fa-search"></i></a>
			</div>
			
			<!-- <bb-spinner size="0.5" ng-show="$ctrl.loading"></bb-spinner> -->
			<!-- <bb-loading [hidden]="!loading"></bb-loading> -->
			<div [hidden]="!loading">loading</div>

			<div class="results-wrapper" [ngClass]="{ 'has-search': (results?.length > 5 || search) }">
				<ul class="results" *ngIf="results && results.length">
					<li *ngFor="let result of results" (click)="selectEntity($event, result)">
						<span [innerHTML]="result.data | statusIcon"></span>
						<span *ngIf="result.label">{{ result.label }}</span>
						<em *ngIf="!result.label" class="no-label">{{ result.data.originalfilename || result.data.id }}</em>
					</li>
					<!-- <li ng-repeat="(index, option) in $ctrl.options" 
						ng-click="$ctrl.selectOption(option)" 
						ng-class="{active: index == $ctrl.activeOptionIndex}" 
						ng-bind-html="option.label"></li> -->
				</ul>
				<div class="no-results" *ngIf="results && results.length === 0">
					{{ 'NO_RESULTS_FOUND' | translate }}
				</div>
			</div>
		</div>
	</div>
</div>

<div class="right-button">
	<i class="fa fa-chevron-down"></i>
</div>
